import React from 'react'
import { Input } from "antd";
import Utils from "Utils";

export function AntInput({
    fieldName,
    value,
    setFieldValue,
    isRequired = false,
    label = null,
    touched = {},
    errors = {},
    options = {} }) {
    return (
        <div className="custom-field flex flex-column">
            <div className={`label ${isRequired && 'required'}`}>{label || Utils.convertSnakeCaseToSpace(fieldName)}</div>
            <Input name={fieldName} value={value} onChange={(e) => setFieldValue(fieldName, e.target.value)} {...options} />
            <div className="error">
                {errors[fieldName] && touched[fieldName] && errors[fieldName]}
            </div>
        </div>
    )
}
